// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ProviderStaffOutlined from '../_raw/ui/provider_staff_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ProviderStaffOutlined);
